import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cherry","clipPath":"url(#clip0_543_6572)"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M14.9997 21.0002C13.6329 22.3671 11.3666 22.3671 9.99974 21.0002C8.6329 19.6334 8.6329 17.3671 9.99974 16.0002C11.3666 14.6334 13.6329 14.6334 14.9997 16.0002C16.3666 17.3671 16.3666 19.6334 14.9997 21.0002Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M7.99974 14.0002C6.6329 15.3671 4.36657 15.3671 2.99974 14.0002C1.6329 12.6334 1.6329 10.3671 2.99974 9.00022C4.36657 7.63339 6.6329 7.63339 7.99974 9.00022C9.36657 10.3671 9.36657 12.6334 7.99974 14.0002Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.99974 9.00003C6.6329 7.63319 4.36657 7.63319 2.99974 9.00003C1.6329 10.3669 1.6329 12.6332 2.99974 14C4.36657 15.3669 6.6329 15.3669 7.99974 14C9.36657 12.6332 9.36657 10.3669 7.99974 9.00003ZM7.99974 9.00003C11.1717 5.82806 17.1521 5.16938 19.2497 5.03432M16.9997 2L21.9997 7M19.2497 5.87694C17.7111 7.7916 15.1381 11.6366 14.9935 15.25M14.9997 16C13.6329 14.6332 11.3666 14.6332 9.99974 16C8.6329 17.3669 8.6329 19.6332 9.99974 21C11.3666 22.3669 13.6329 22.3669 14.9997 21C16.3666 19.6332 16.3666 17.3669 14.9997 16Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Cherry = Vue.extend<IconProps>({
  name: 'CherryIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cherry',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Cherry;
